import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import {
    FetchRequestOptions,
    fetchService,
    CORS_MODE_NAME,
    GET_METHOD_NAME,
} from 'owa-data-provider-info-fetcher';
import { format } from 'owa-string-utils';
import { getEncodedUrlForVroom } from 'owa-data-provider-info-fetcher';
import { ONE_DRIVE_CONUSMER_API_URL } from 'owa-fileprovider-services';

const getFileInfoRequestUrlFormat: string = '{0}/v1.0/shares/{1}/driveItem';

export async function getODCDriveItem(url: string): Promise<GetODCDriveItemResponse> {
    const requestUrl: string = format(
        getFileInfoRequestUrlFormat,
        ONE_DRIVE_CONUSMER_API_URL,
        getEncodedUrlForVroom(url)
    );
    const requestOptions: FetchRequestOptions = {
        method: GET_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: null,
        datapointNamePrefix: 'GetODCDriveItem',
    };

    const responseText: string = await fetchService(
        AttachmentDataProviderType.OneDriveConsumer,
        requestUrl,
        null,
        requestOptions,
        null
    );

    return JSON.parse(responseText);
}

export interface GetODCDriveItemResponse {
    id: string;
    name: string;
    file: ODCFile;
}

interface ODCFile {
    mimeType: string;
}
